/** How two values at the same path combine. */
export enum MergeType {
  OTHER,
  RECORD,
  ARRAY,
  SET,
  MAP,
}

export function determineMergeType(value: any): MergeType {
  if (Array.isArray(value)) {
    return MergeType.ARRAY;
  }
  if (value instanceof Set) {
    return MergeType.SET;
  }
  if (value instanceof Map) {
    return MergeType.MAP;
  }
  if (typeof value === 'object' && value !== null) {
    return MergeType.RECORD;
  }
  return MergeType.OTHER;
}
